import React from 'react';
import LicenseGate from '../components/ui/LicenseGate';
import { ChartGuideModal } from '../components/ui';
import useChartGuide from '../hooks/useChartGuide';
import { EvaluationGrowthTable, EvaluationGrowthGuide } from '../components/smartEvaluation';

interface Brand {
  id: number;
  name: string;
}

interface Branch {
  id: number;
  name: string;
}

interface EvaluationGrowthDashboardProps {
  selectedBranch?: Branch | null;
  selectedBrand?: Brand | null;
}

const EvaluationGrowthDashboard: React.FC<EvaluationGrowthDashboardProps> = ({ selectedBranch, selectedBrand }) => {
  const { isModalOpen, currentGuide, closeGuide } = useChartGuide();

  return (
    <LicenseGate licenseType="evaluation" dashboardName="داشبورد عملکرد کلی ارزیابی هوشمند">
      <div dir="rtl" className="container-dashboard">
        <div className="space-y-8 md:space-y-10 animate-enter-up">
          {/* Header */}
          <div>
            {/* نوار ابزارِ راهنما در گوشه‌ی بالا (تراز چپ در RTL) به‌جای وسطِ صفحه */}
            <div className="flex justify-end mb-3">
              <EvaluationGrowthGuide
                branchName={selectedBranch?.name}
                brandName={selectedBrand?.name}
              />
            </div>
            <h1 className="title-dashboard">داشبورد عملکرد کلی ارزیابی هوشمند</h1>
            <p className="text-sm text-text-secondary mt-2 text-center">
              مقادیر ماهانه‌ی شاخص‌های ارزیابی به‌همراه رشد ماه‌به‌ماه — به‌صورت جدولی با قابلیت مرتب‌سازی و نمایش نمودار
            </p>
          </div>

          <div id="section-evaluation-growth-table" className="dashboard-section-anchor">
            <EvaluationGrowthTable
              branchId={selectedBranch?.id}
              branchName={selectedBranch?.name}
              brandName={selectedBrand?.name}
            />
          </div>
        </div>

        {currentGuide && (
          <ChartGuideModal isOpen={isModalOpen} onClose={closeGuide} title={currentGuide.title}>
            <div className="space-y-8">
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-2">توضیحات</h3>
                <p className="text-text-secondary">{currentGuide.description}</p>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-2">نحوه تفسیر</h3>
                <p className="text-text-secondary">{currentGuide.interpretation}</p>
              </div>
              {currentGuide.tips.length > 0 && (
                <div>
                  <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-2">نکات کلیدی</h3>
                  <ul className="list-disc list-inside space-y-2">
                    {currentGuide.tips.map((tip, index) => (
                      <li key={index} className="text-text-secondary">{tip}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </ChartGuideModal>
        )}
      </div>
    </LicenseGate>
  );
};

export default EvaluationGrowthDashboard;
